module.exports = __webpack_public_path__ + "img/Fahrradgarage-grau-mit-Fahrradmotiv-und-Smartphone-1.d86d3c95.png";